
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import moment from 'moment'
import { BarChart, DashboardGraph } from 'graph'
import { useGraphFetch, constants } from '../module'
import { useSelectedFleetIds } from 'features/settings'
import { v4 as uuid } from 'uuid'

const STATUS_LABELS = ['expired', 'overdue', 'matured']

const Graph = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const selectedFleetIds = useSelectedFleetIds()

  const { loading, error, data } = useGraphFetch()
  const path = '/reports/wof-registration'

  const onClick = (_, node) => {
    if (!data || !node || !node[0]) {
      return
    }

    const index = node[0]._index ?? node[0].index
    if (index === undefined || index === null) {
      return
    }

    const rawLabel = data.labels?.[index]
    const labelString = (Array.isArray(rawLabel) ? rawLabel.join(' ') : String(rawLabel ?? '')).trim().toLowerCase()

    if (STATUS_LABELS.includes(labelString)) {
      navigate(`${path}?wofStatus=Overdue`)
      return
    }

    const rangeDate = data.ranges?.[index]
    if (rangeDate) {
      const dateMoment = moment(rangeDate).utc()
        .date(1)
      if (dateMoment.isValid()) {
        dispatch({ type: 'reportWofRego_set_dashboard_filter', payload: true })
        navigate(`${path}?range=${dateMoment.format('MMMM YYYY')}`)
      }
    }
  }

  const onRefresh = () => {
    dispatch({
      type: constants.REQUEST_DATA,
      payload: null,
      options: { queryParams: { FleetId: selectedFleetIds.join() }, requestId: uuid() }
    })
  }

  return (
    <DashboardGraph
      title="WoF Expiry"
      to={path}
      loading={loading}
      error={error}
      onRefresh={onRefresh}
      data={data}>
      {data && (
        <BarChart
          data={data}
          showHealthAndSafetyDisclaimer
          noDataMessage="Our current data shows that you have no vehicles requiring a WOF/Registration renewal in the next 6 months."
          onClick={onClick}/>
      )}
    </DashboardGraph>
  )
}

export default Graph
